import React, { useEffect, useState } from 'react';
import DashboardService from 'js-promo-partners-lib/lib/services/dashboard-service/dashboard-service';
import VideoService from 'js-promo-partners-lib/lib/services/video-service/video-service';
import userService from 'js-promo-partners-lib/lib/services/user-service/user-service';
import DashboardPage from 'js-promo-partners-lib/lib/components/dashboard-page/dashboard-page';
import 'js-promo-partners-lib/lib/components/dashboard-page/dashboard-page.scss';
import './app-dashboard-page.scss';

import DashboardHeader from 'js-promo-partners-lib/lib/components/layout/wordpress/dashboard-header/dashboard-header';
import 'js-promo-partners-lib/lib/components/layout/header/header.scss';

import supportService from '../../services/support-service/support-service';
import httpClient from '../../services/http-client/http-client';

import URLS from '../../services/wordpress-app-urls';
import APP_TYPES from '../../services/app-types';

import getConfig from '../../config';
import WithApp from '../hoc/with-app/with-app';

const {
    jwtUrl, nonce, apiUrl, appName,
} = getConfig();

const videoService = new VideoService(apiUrl, httpClient);
const dashboardService = new DashboardService(apiUrl, httpClient);

const AppDashboardPage = () => {
    const [drafts, setDrafts] = useState(null);
    const [published, setPublished] = useState(null);
    const [account, setAccount] = useState(null);

    useEffect(() => {
        async function getUserVideos () {
            const userVideos = await dashboardService.getUserVideos();
            setDrafts(userVideos.drafts);
            setPublished(userVideos.published);

            // gets the user account
            setAccount(httpClient.getUserAccount());
        }

        async function getJwt () {
            // stores the jwt url and nonce inside the storage
            httpClient.setJwtUrl(undefined, jwtUrl);
            httpClient.setNonce(undefined, nonce);
            // fetch the JWT
            const { jwt } = await httpClient.getJwt(undefined, jwtUrl);
            // sets the JWT inside the storage
            httpClient.setJWT(undefined, jwt);
            // fetch the user videos
            getUserVideos();
        }
        getJwt();
    }, []);


    const onCreate = () => {
        window.open(URLS.TEMPLATE);
    };

    const onEdit = (id) => {
        window.open(URLS.EDIT(id));
    };

    const onPublish = (id, renderingDuration) => {
        window.open(URLS.PUBLISH(id, renderingDuration));
    };

    const onBillingClick = () => {
        window.open(URLS.BILLING);
    };

    const onFaqClick = () => {
        window.open(URLS.FAQ);
    };

    const onPricingClick = () => {
        window.open(URLS.PRICING);
    };

    const onSendSupportMessage = message => supportService.sendSupportMessage(message);

    if (!account) {
        return (null);
    }

    const { firstName, lastName } = account;
    const fullName = userService.getFullName(firstName, lastName);

    const hasPricing = appName === APP_TYPES.WOOCOMMERCE;

    return (
        <div className='app-dashboard-page'>
            <DashboardHeader
                onCreateClick={onCreate}
                onFaqClick={onFaqClick}
                onSendSupportMessage={onSendSupportMessage}
                hasPricing={hasPricing}
                onPricingClick={onPricingClick}
                hasUpgrade={hasPricing}
                onUpgradeClick={onPricingClick}
                hasBilling={hasPricing}
                onBillingClick={onBillingClick}
                fullName={fullName}
                storeName='Promo Video Maker'
                storeDomain={fullName}
            />
            <DashboardPage
                dashboardService={dashboardService}
                videoService={videoService}
                onCreate={onCreate}
                onEdit={onEdit}
                onPublish={onPublish}
                drafts={drafts}
                published={published}
            />
        </div>
    );
};

export default WithApp(AppDashboardPage);
